import { formatUnits, parseUnits } from 'ethers/lib/utils';
import usePoolState from '../../../../context/pool/usePoolState';
import { formatUSD } from '../../../../helpers';
import useTokenDetails from '../../../../hooks/web3/useTokenDetails';
import { EnabledChains } from '../../../../config/constants';
import { useWeb3React } from '@web3-react/core';
import { config } from '../../../../config/config';

const NoLockWarning = () => {
    const { chainId } = useWeb3React();

    const { depositAmount, selectedLiquidityPool } = usePoolState();

    const { decimals } = useTokenDetails(
        config.addresses[chainId as EnabledChains[number]]?.collateral
    );

    const converted = selectedLiquidityPool
        ? selectedLiquidityPool.isZeroPrice
            ? '0'
            : formatUnits(
                  parseUnits(depositAmount || '0', decimals)
                      .mul(parseUnits('1', decimals))
                      .div(
                          parseUnits(selectedLiquidityPool.currentPriceEstimate, decimals)
                      ),
                  decimals
              )
        : undefined;

    return (
        <div className='no-lock-warning'>
            <p>
                You are about to deposit{' '}
                <strong>
                    {depositAmount
                        ? formatUSD(depositAmount, { minDecimals: 2, currency: '' })
                        : '-'}
                </strong>{' '}
                USDC for{' '}
                <strong>
                    {converted
                        ? formatUSD(converted, { minDecimals: 2, currency: '' })
                        : '-'}
                </strong>{' '}
                {selectedLiquidityPool?.lpToken} with <strong>No Lock</strong>. <br /> The
                following restrictions are in effect:
            </p>
            <ul>
                <li>
                    A <strong>mandatory lock of 6 hours</strong> applies to each No Lock
                    deposit.
                </li>
                <li>
                    A <strong>0.3% fee</strong> is applied, should you choose to withdraw
                    within the first 72 hours of your deposit.
                </li>
            </ul>
        </div>
    );
};

export default NoLockWarning;
